import { fetchAuthSession } from '@aws-amplify/core';
import { Safari16API } from '@chiroup/client-core/functions/Safari16API';
import { initSentryFrontend } from '@chiroup/core/config/sentryFrontend';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Initialize React for global access
window.React = React;

const VITE_CHIROUP_API = import.meta.env.VITE_CHIROUP_API as string;

// Hint the browser to warm up connections to our API host early
try {
  const apiUrl = new URL(VITE_CHIROUP_API);
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = apiUrl.origin;
  preconnect.crossOrigin = '';
  document.head.appendChild(preconnect);

  const dnsPrefetch = document.createElement('link');
  dnsPrefetch.rel = 'dns-prefetch';
  dnsPrefetch.href = apiUrl.origin;
  document.head.appendChild(dnsPrefetch);
} catch {
  console.error('Failed to warm up connections to our API host early');
}

// Initialize Sentry with shared configuration
initSentryFrontend({
  dsn: 'https://4e31ca6b060ff97a5d318de5b6ad29a8@o4506354335612928.ingest.sentry.io/4506354340265984',
  apiEndpoint: VITE_CHIROUP_API,
  stage: import.meta.env.VITE_STAGE,
  version: import.meta.env.VITE_VERSION,
});

const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    allowGuestAccess: false,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
    userPoolClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID as string,
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID as string,
  },
};

Amplify.configure(
  {
    Auth: authConfig,
    API: {
      REST: {
        api: {
          endpoint: import.meta.env.VITE_CHIROUP_API as string,
        },
        'api-noauth': {
          endpoint: import.meta.env.VITE_CHIROUP_API as string,
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async () => {
          const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();

          return {
            Authorization: `Bearer ${authToken}`,
          };
        },
        retryStrategy: {
          strategy: 'no-retry',
        },
      },
    },
  }
);

// Configure Safari16API fallback for Safari 16.0 compatibility
Safari16API.configure({
  api: import.meta.env.VITE_CHIROUP_API as string,
  'api-noauth': import.meta.env.VITE_CHIROUP_API as string,
});

// Ensure the root element exists
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

// Create root and render
const root = createRoot(container);
root.render(
  // <React.StrictMode>
  // <AppMRUProvider>
  <App />
  // </AppMRUProvider>
  // </React.StrictMode>
);
// [2025-07-03 by Brian] Disabled StrictMode per JG as it was doubling
// expensive REST calls when running locally.
